import React, { MouseEventHandler, useEffect } from "react"
import { useHistory } from "react-router-dom"

import styled from "styled-components"

import { useLocalization } from "@izettle/lingo-client"
import { spacing } from "@izettle/otto"
import { Text, Button } from "@izettle/react"

import { Cancel } from "@/components/cancel"
import { PageWrapper } from "@/components/layout-helpers"
import { useSetPageTitle } from "@/components/page-title"
import { PreviewImage } from "@/components/preview-image"
import { baseUrl } from "@/constants"

const PageTitle = styled(Text.Title3)`
  text-align: center;
  margin: ${spacing.small} ${spacing.none} ${spacing.xxSmall} ${spacing.none};
`

const InfoText = styled(Text.Regular)`
  text-align: center;
  margin: ${spacing.none} ${spacing.none} ${spacing.small} ${spacing.none};
`

const textMapper = {
  "upload-front": {
    title: "CONFIRM_UPLOAD_TITLE_FRONT_SIDE",
    text: "CONFIRM_UPLOAD_TEXT_FRONT_SIDE",
    button: "PURPOSE_SUBMIT_BUTTON_FRONT_SIDE"
  },
  "upload-back": {
    title: "CONFIRM_UPLOAD_TITLE_BACK_SIDE",
    text: "CONFIRM_UPLOAD_TEXT_BACK_SIDE",
    button: "PURPOSE_SUBMIT_BUTTON_BACK_SIDE"
  },
  "upload": {
    title: "CONFIRM_UPLOAD_TITLE_NEW",
    text: "CONFIRM_UPLOAD_TEXT",
    button: "PURPOSE_SUBMIT_BUTTON"
  }
}

type BeforeUploadProps = {
  alt?: string
  imgUrl?: string
  isPDF: boolean
  path: "upload-front" | "upload-back" | "upload"
  onClick: MouseEventHandler<HTMLButtonElement>
}

export const BeforeUpload: React.FC<BeforeUploadProps> = ({
  alt,
  imgUrl,
  isPDF,
  path,
  onClick,
}) => {
  const { text } = useLocalization()
  const { setPageTitle } = useSetPageTitle()
  const history = useHistory()

  const StyledButton = styled(Button)`
    margin-top : ${spacing.xxSmall};
  `

  const handleTryAgain = () => {
    history.push(`${baseUrl}/proofOfIdentity`)
  }

  useEffect(() => {
    setPageTitle(text("PROOF_OF_IDENTITY"))
  }, [])

  return (
    <PageWrapper>
      <Cancel url={`${baseUrl}/proofOfIdentity`} />
      <PageTitle>{text(textMapper[path].title)}</PageTitle>
      <InfoText>{text(textMapper[path].text)}</InfoText>
      <PreviewImage alt={alt} imgUrl={imgUrl} isPDF={isPDF} />
      <Button onClick={onClick}>{text(textMapper[path].button)}</Button>
      <StyledButton onClick={handleTryAgain} variant="secondary">{text('RETRY')}</StyledButton>
    </PageWrapper>
  )
}
